import { Box, Button, Slider, Typography } from "@mui/material";
import { SetStateAction, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import VerifiedUser from "@mui/icons-material/VerifiedUser";

export default function AmountSlider() {
  const [amount, setAmount] = useState(1000);

  const getHintText = (val: number) => {
    if (val <= 600) return "Just enough to get started";
    if (val <= 1000) return "Smart choice for new renters";
    return "Maximum support for full rental setup";
  };

  return (
    <Box
      sx={{
        mb: 4,
        backgroundColor: "background.paper",
        p: 4,
        pb: 3,
        borderRadius: 3,
        boxShadow: "0 0 10px rgba(0,0,0,0.05)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        gutterBottom
        sx={{
          fontWeight: 600,
          fontSize: { xs: "1.3rem", md: "1.7rem" },
          color: "text.primary",
        }}
      >
        Select the amount that fits your rental needs
      </Typography>

      <Typography
        variant="h4"
        sx={{ fontWeight: 700, color: "primary.main", mb: 1 }}
      >
        ${amount} bond
      </Typography>

      <Slider
        value={amount}
        min={500}
        max={2000}
        step={25}
        //@ts-ignore
        onChange={(_, value) => setAmount(value)}
        sx={{
          height: 10,
          borderRadius: 2,
          "& .MuiSlider-thumb": {
            height: 22,
            width: 22,
            backgroundColor: "#fff",
            border: "2px solid #555",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          },
          "& .MuiSlider-track": {
            background:
              "linear-gradient(to right, primary.light, primary.dark)",
            border: "none",
          },
          "& .MuiSlider-rail": {
            opacity: 0.3,
            backgroundColor: "#ccc",
          },
        }}
      />

      <Typography
        sx={{
          mt: 1,
          color: "text.secondary",
          fontSize: "0.9rem",
          textAlign: "center",
        }}
      >
        {getHintText(amount)}
      </Typography>

      <Button
        sx={{ alignSelf: "center", mt: 3 }}
        variant="contained"
        size="large"
        color="secondary"
        component={RouterLink}
        to={`/apply?amount=${amount}`}
      >
        Apply Now
      </Button>

      <Typography
        sx={{
          mt: 2,
          alignSelf: "center",
          display: "flex",
          gap: 1,
          color: "text.secondary",
          fontSize: { xs: "0.75rem", md: "0.875rem" },
        }}
      >
        <VerifiedUser sx={{ color: "lightgreen" }} fontSize={"small"} />
        Safe and Secure. 2 min application
      </Typography>
    </Box>
  );
}
